const moneyFormatters: Record<string, Intl.NumberFormat> = {};

/** `44.1` → `$44.10`; negative amounts keep their minus sign (refunds, disputes). */
export const formatMoney = (value: number | null | undefined, currency = 'USD') => {
  if (value === null || value === undefined || Number.isNaN(value)) return '—';
  const fmt = (moneyFormatters[currency] ??= new Intl.NumberFormat('en-US', { style: 'currency', currency }));
  return fmt.format(value);
};

/** ISO timestamp → `Sep 29, 2026`. */
export const formatDate = (iso: string | null | undefined) => {
  if (!iso) return '—';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return '—';
  return d.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
};

/** `2026-09` → `September 2026`. Periods are UTC months, so format in UTC. */
export const formatPeriod = (period: string | null | undefined, month: 'long' | 'short' = 'long') => {
  if (!period) return '—';
  const [y, m] = period.split('-').map(Number);
  if (!y || !m) return period;
  return new Date(Date.UTC(y, m - 1, 1)).toLocaleDateString('en-US', { month, year: 'numeric', timeZone: 'UTC' });
};

/** `0.1` → `10%`. */
export const formatRate = (rate: number | null | undefined) => (rate === null || rate === undefined ? '—' : `${+(rate * 100).toFixed(2)}%`);

const PLAN_NAMES: Record<string, string> = { AI_TEAM: 'AI Team', FIRST_HIRE: 'First Hire', FULL_WORKFORCE: 'Full Workforce' };

/** `FULL_WORKFORCE` → `Full Workforce`; an unknown code is title-cased. */
export const formatPlan = (code: string | null | undefined) => {
  if (!code) return '—';
  return PLAN_NAMES[code] ?? code.toLowerCase().replace(/(^|_)(\w)/g, (_, sep, c) => (sep ? ' ' : '') + c.toUpperCase());
};

/** `past_due` → `Past due`, for status values the UI has no label for. */
export const humanize = (value: string | null | undefined) => {
  if (!value) return '—';
  const s = value.replace(/_/g, ' ');
  return s.charAt(0).toUpperCase() + s.slice(1);
};
